import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  const timeline = [{
    day: 'Día 1',
    text: '🌅 Primer día: Notarás que llegar al baño es más fácil. Esa sensación de pesadez matutina empieza a desaparecer.'
  }, {
    day: 'Día 4',
    text: '⚡ Día 4: El dolor lumbar al agacharte habrá disminuido a la mitad. Te sentirás con más energía.'
  }, {
    day: 'Día 7',
    text: '🏃 Día 7: Te sorprenderás bajando las escaleras sin tener que sostenerte del pasamanos con ambas manos. Recuperas tu libertad.'
  }];
  return <section className="bg-[#FDF6EE] text-stone-800 py-24 px-4" data-id="element-157">
      <div className="max-w-5xl mx-auto" data-id="element-158">
        <FadeIn data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-black mb-16 text-center text-stone-900" data-id="element-160">
            ¿Qué cambia en 7 días?
          </h2>

          <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-161">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-amber-200 -z-10" data-id="element-162" />

            {timeline.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-163">
                <div className="flex flex-col items-center text-center" data-id="element-164">
                  <div className="w-24 h-24 rounded-full bg-amber-100 border-4 border-amber-500 flex items-center justify-center mb-6 shadow-lg" data-id="element-165">
                    <span className="text-xl font-black text-amber-800" data-id="element-166">
                      {item.day}
                    </span>
                  </div>
                  <p className="text-lg md:text-xl text-stone-600 font-medium leading-relaxed px-4" data-id="element-167">
                    {item.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}